import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import LayoutHeader from "./layoutHeader";
import Employee_Dashboard from "../user/employee_dashboard/employee_dashboard";
import ProtectedRoute from "./ProtectedRoute";
import SideBaruser from "./sideBar";
import ProjectIndex from "../user/project/indexTask";
import ProjectView from "../user/project/projectView";
import TaskIndex from "../user/task/taskIndex";
import ProfileIndex from "../user/profile";
import LeaveDetails from "../user/leaveDetails/leaveDetails";
import Salary_Details from "../user/profile/salary_Details";

const UserNavigation = () => {
  const user = useSelector((state: any) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { Sider, Content } = Layout;

  return (
    <Layout>
      <Sider
        style={{ backgroundColor: "#FF1A1A", height: "100vh" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? 40 : 250}
      >
        <SideBaruser
          collapsed={collapsed}
          doCollapse={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Layout>
        <LayoutHeader />
        <Content style={{ background: "#fff" }}>
          <Routes>
            <Route path="/" element={<Employee_Dashboard />} />

            <Route
              path="/Employee_Dashboard"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Employee_Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/project_view/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ProjectIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Project_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ProjectView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/task_view/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TaskIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ProfileIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Leave_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <LeaveDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/viewSalaryDetails"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Salary_Details />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default UserNavigation;
